module.exports = __webpack_public_path__ + "static/media/pic3.dc759226.jpg";